import { API_BASE_URL } from "../../../services/api";

/** Fixture prefix: path after this is served from CRA `public/` (see `PUBLIC_URL`). */
const PUBLIC_DUMMY_PREFIX = "__patrol_public__/";

/**
 * Resolves a patrol `recording_path` (or similar media path) to a browser-loadable URL.
 * - Absolute `http:` / `https:` URLs are returned unchanged.
 * - Values prefixed with `__patrol_public__/` map to files under `public/`.
 * - Any other relative path is prefixed with `API_BASE_URL`.
 *
 * @param {string | null | undefined} recordingPath
 * @returns {string}
 */
export function resolvePatrolMediaUrl(recordingPath) {
  if (recordingPath == null || typeof recordingPath !== "string") return "";
  const trimmed = recordingPath.trim();
  if (!trimmed) return "";
  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  if (trimmed.startsWith(PUBLIC_DUMMY_PREFIX)) {
    const relative = trimmed
      .slice(PUBLIC_DUMMY_PREFIX.length)
      .replace(/^\/+/, "");
    if (typeof window === "undefined" || !window.location?.origin) {
      return `/${relative}`;
    }
    const base = `${window.location.origin}${process.env.PUBLIC_URL || ""}`.replace(
      /\/$/,
      "",
    );
    return `${base}/${relative}`;
  }

  const base = String(API_BASE_URL || "").replace(/\/$/, "");
  const path = trimmed.replace(/^\/+/, "");
  if (!base) return `/${path}`;
  return `${base}/${path}`;
}
